import { useNavigate } from 'react-router-dom';
import { CustomerTaskDto, CustomerTaskTypeEnum } from '../models';
import { getApplicationTaskFormAction } from '../services/formActions.service';
import { useFormActionHandler } from './useFormActionHandler';

export const useCustomerTaskClickHandler = () => {
  const navigate = useNavigate();
  const formActionHandler = useFormActionHandler();

  const applicationTaskHandler = (task: CustomerTaskDto) => {
    navigate(`/applications/${task.id}`);
  };

  const formTaskHandler = (task: CustomerTaskDto) => {
    const submittedOrEdit = task.active ? 'edit' : 'submitted';

    navigate(`/forms/${submittedOrEdit}/${task.id}`);
  };

  const retiredFormNotification = async () => {
    // Navigate to the retired form notification for conference attendance
    navigate(`/forms/application/application-conference-attendance`);
  };

  const inflowTaskHandler = async (task: CustomerTaskDto) => {
    if (task.data?.taskType == 'sign-document') {
      const signingUrl = task.data?.signingUrl;
      if (signingUrl) window.open(signingUrl, '_blank');
    } else {
      const applicationId = task.data?.applicationId;
      const formAction = await getApplicationTaskFormAction(applicationId, task.id as string);

      await formActionHandler(formAction);
    }
  };

  return async (task: CustomerTaskDto) => {
    switch (task.type) {
      case CustomerTaskTypeEnum.Application:
        applicationTaskHandler(task);
        break;
      case CustomerTaskTypeEnum.Forms:
        formTaskHandler(task);
        break;
      case CustomerTaskTypeEnum.Inflow:
        await inflowTaskHandler(task);
        break;
      case CustomerTaskTypeEnum.ConferenceGrant:
        await retiredFormNotification();
        break;
      default:
        console.error(`No task click handler for task type ${task.type}`);
    }
  };
};
